import * as d3 from 'd3';

/**
 * Whether a geographic point lies on the visible (near) hemisphere of an
 * orthographic globe projection.
 *
 * D3's orthographic projection returns screen coordinates for *every* point —
 * including those on the far side of the globe. `clipAngle` only affects the
 * `geoPath` stream, not direct `projection([lon, lat])` calls. As a result,
 * elements projected point-by-point (aircraft, airports, trails) keep rendering
 * and drift with the camera once the globe is rotated away from them (TSMED-1407).
 *
 * Callers use this to skip rendering back-facing elements. A point is on the near
 * hemisphere when its angular distance to the projection center is within 90°.
 */
export const isGeoPointVisible = (
  projection: d3.GeoProjection,
  [longitude, latitude]: [number, number],
): boolean => {
  const [rotateLambda, rotatePhi] = projection.rotate();
  // The geographic point facing the viewer is the negated rotation. The roll
  // (gamma) component is ignored because it spins the globe in-plane without
  // changing which hemisphere faces the viewer; the map never sets a roll anyway.
  const center: [number, number] = [-rotateLambda, -rotatePhi];

  return d3.geoDistance(center, [longitude, latitude]) <= Math.PI / 2;
};
